var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        {
          attrs: {
            "border-color": _vm.data.status.color,
            controlled: "",
            "has-toggle": "",
            opened: _vm.data.opened
          },
          on: {
            "click:open": function($event) {
              return _vm.toggle(_vm.sections.AdditionalInfo)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "bg-gray p-3" }, [
                    _c(
                      "div",
                      { staticClass: "bg-white p-3 rounded" },
                      [
                        _vm.isAdditionalInfoOpen
                          ? _c("additional-info", {
                              attrs: { value: _vm.data }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row py-2 mr-md-0 n-ml" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md text-center border-right" },
              [
                _c(
                  "div",
                  {
                    class: `badge badge-pill font-14 mt-3 py-2 mx-auto`,
                    style: { "background-color": "#fed8bc", color: "#d44d28" }
                  },
                  [_vm._v(" " + _vm._s(_vm.data.area.name) + " ")]
                ),
                _c("div", [
                  _c("span", { staticClass: "font-16 text-muted" }, [
                    _vm._v(" No. de Cuestionario: ")
                  ])
                ]),
                _c("div", [
                  _c("span", { staticClass: "font-16 color-black" }, [
                    _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.number)) + " ")
                  ])
                ])
              ]
            ),
            _c("div", { staticClass: "col-12 col-md-9" }, [
              _c("div", { staticClass: "row pt-2 align-items-center" }, [
                _c("div", { staticClass: "col-12 col-md-8 custom-pl" }, [
                  _c("div", { staticClass: "d-flex flex-column" }, [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Nombre del Cuestionario: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("empty")(_vm.data.questionnaireType.name)
                          ) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md custom-pl" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column" },
                    [
                      _c("label", { staticClass: "text-muted" }, [
                        _vm._v("Estatus:")
                      ]),
                      _c("custom-balloon", {
                        attrs: {
                          "background-color": _vm.data.status.color,
                          dot: "",
                          text: _vm.data.status.name
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 col-md custom-pl text-md-center" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("dropdown", {
                          staticClass: "actions-dropdown",
                          attrs: { items: _vm.actionItems, title: "Acciones" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }